module.exports = __webpack_public_path__ + "img/chevron-up.9c21e882.svg";